import React from "react";
import { Link } from "react-router-dom";

import "./Oferta.css";

const SpecialMenu = () => {

    document.addEventListener("DOMContentLoaded", function(event) {
        document.addEventListener("scroll", function(event) {
            const animatedBoxes = document.getElementsByClassName("animated-box");
            const windowOffsetTop = window.innerHeight + window.scrollY;
    
            Array.prototype.forEach.call(animatedBoxes, (animatedBox) => {
                const animatedBoxOffsetTop = animatedBox.offsetTop;
    
                if (windowOffsetTop >= animatedBoxOffsetTop) {
                    addClass(animatedBox, "fade-in");
                }
            });
        });
    });
    
    function addClass(element, className) {
        const arrayClasses = element.className.split(" ");
        if (arrayClasses.indexOf(className) === -1) {
            element.className += " " + className;
        }
    }

return (
    <div className="app__specialMenu app__bg " id="oferta">

            <hr className="hr1"/>
        <div className="app__specialMenu-title">
            
            <h1 className="oferta-h1">Oferta</h1>
        </div>
        <div className="app__oferta animated-box">
            <div className="app__oferta-menu1">
                <p className="app__menu_heading">
                    TRENING PERSONALNY
                </p>
                <p className="white">
                    Jest to oferta dla osób, które chcą nauczyć się trenować w
                    świadomy sposób oraz poprawić swoje zdrowie i kondycję.
                </p>
                <div className="butt">
                    <button type="button" className="customm__butt">
                        <Link
                            to="/TreningPersonalny"
                            target="_self"
                            rel="noopener noreferrer"
                        >
                            Zobacz Więcej
                        </Link>
                    </button>
                </div>
            </div>


            <div className="app__oferta-menu5">
                <p className="app__menu_heading">
                    WSPÓŁPRACA ONLINE
                </p>
                <p className="white">
                    Oferta dla osób, które potrzebują prowadzenia w trybie
                    online.
                </p>
                
                <div className="butt1">
                    <button type="button" className="customm__butt">
                        <Link
                            to="/Współpraca"
                            target="_self"
                            rel="noopener noreferrer"
                        >
                            Zobacz Więcej
                        </Link>
                    </button>
                </div>
            </div>

            <div className="app__oferta-menu6">
                <p className="app__menu_heading">
                    PLANY TRENINGOWE I DIETETYCZNE
                </p>
                <p className="white">
                Plany rozpisywane pod Twoje indywidualne preferencje żywieniowe oraz Twój cel treningowy.
                </p>
                   
                <div className="butt2">
                    <button type="button" className="customm__butt">
                        <Link
                            to="/PlanyTD"
                            target="_self"
                            rel="noopener noreferrer"
                        >
                            Zobacz Więcej
                        </Link>
                    </button>
                </div>
            </div>
            {/* </div> */}
        </div>

    </div>
);
}

export default SpecialMenu;
